import Swal from "sweetalert2";
import store from "@/store";
export function toast(text) {
  Swal.fire({
    position: "center",
    icon: "success",
    title: text,
    showConfirmButton: false,
    timer: 2500,
  });
}

export function toastError(text) {
  Swal.fire({
    position: "center",
    icon: "error",
    title: text,
    showConfirmButton: false,
    showCloseButton: true,
  }).then(() => {
    store.dispatch("setLoading", false);
  });
}
